import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "faq",
  class: "faq",
  "aria-labelledby": "faq-title"
}
const _hoisted_2 = { class: "container faq__layout" }
const _hoisted_3 = { class: "faq__groups" }
const _hoisted_4 = { "aria-hidden": "true" }

import { onMounted, onBeforeUnmount } from "vue";
import { faqGroups } from "@/content/faq";

export default /*@__PURE__*/_defineComponent({
  __name: 'SiteFaq',
  setup(__props) {

let schema: HTMLScriptElement | undefined;
onMounted(() => {
  schema = document.createElement("script");
  schema.type = "application/ld+json";
  schema.id = "allading-faq-schema";
  schema.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqGroups.flatMap((group) =>
      group.items.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      }))
    ),
  });
  document.head.appendChild(schema);
});
onBeforeUnmount(() => schema?.remove());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"faq__intro\" data-v-4558f31e><p class=\"eyebrow\" data-v-4558f31e>Allading, explained</p><h2 id=\"faq-title\" data-v-4558f31e>Good questions.<br data-v-4558f31e>Clear answers.</h2><p data-v-4558f31e> Explore messaging, calls, privacy and backup, with a clear picture of how Allading works. </p><a href=\"#download\" class=\"faq__link\" data-v-4558f31e>Get Allading <span aria-hidden=\"true\" data-v-4558f31e>↗</span></a></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faqGroups), (group, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: group.title,
            class: "faq__group"
          }, [
            _createElementVNode("h3", null, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(String(index + 1).padStart(2, "0")), 1),
              _createTextVNode(_toDisplayString(group.title), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
              return (_openBlock(), _createElementBlock("details", {
                key: item.question,
                class: "faq__item"
              }, [
                _createElementVNode("summary", null, [
                  _createTextVNode(_toDisplayString(item.question), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", {
                    class: "faq__toggle",
                    "aria-hidden": "true"
                  }, null, -1))
                ]),
                _createElementVNode("p", null, _toDisplayString(item.answer), 1)
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})